"use strict";
exports.__esModule = true;
exports.DialogFooter = exports.DialogBody = exports.DialogHeader = exports.Dialog = exports.EditorMode = exports.BlockLabel = exports.BlockSetupCommon = exports.BlockSetup = exports.BlockConfigPanel = exports.BlockToolbarButton = exports.BlockToolbar = exports.BlockIframePreview = void 0;
var _a = window.MTBlockEditor.Component, BlockIframePreview = _a.BlockIframePreview, BlockToolbar = _a.BlockToolbar, BlockToolbarButton = _a.BlockToolbarButton, BlockConfigPanel = _a.BlockConfigPanel, BlockSetup = _a.BlockSetup, BlockSetupCommon = _a.BlockSetupCommon, BlockLabel = _a.BlockLabel, EditorMode = _a.EditorMode, Dialog = _a.Dialog, DialogHeader = _a.DialogHeader, DialogBody = _a.DialogBody, DialogFooter = _a.DialogFooter;
exports.BlockIframePreview = BlockIframePreview;
exports.BlockToolbar = BlockToolbar;
exports.BlockToolbarButton = BlockToolbarButton;
exports.BlockConfigPanel = BlockConfigPanel;
exports.BlockSetup = BlockSetup;
exports.BlockSetupCommon = BlockSetupCommon;
exports.BlockLabel = BlockLabel;
exports.EditorMode = EditorMode;
exports.Dialog = Dialog;
exports.DialogHeader = DialogHeader;
exports.DialogBody = DialogBody;
exports.DialogFooter = DialogFooter;
